/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { Link } from "react-router-dom";

import { isNull,isObjEmpty,ChangeMobileFormat,ChangeDateStringOnlyDate,addThousandPoint,ShowDeliveryStatus,ShowColorDeliveryStatus } from "../common/Common";

const DeliveryCard = ({ varDeliveryData }) => {
  //인수증결제방법
  const [varReceiptPayment,setReceiptPayment] = useState('없음');
  useEffect(() => {
    //인수증결제방법
    if(!isNull(varDeliveryData.dc_receipt_payment)){
      const paymentArray = varDeliveryData.dc_receipt_payment.split(',');
      let soptions = "";
      if(Number(paymentArray[1]) === 1) soptions += " ● 우편 ";
      if(Number(paymentArray[2]) === 1) soptions += " ● 사진 ";
      if(Number(paymentArray[3]) === 1) soptions += " ● 팩스 ";
      if(Number(paymentArray[0]) === 1) soptions += "없음";
      setReceiptPayment(soptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isObjEmpty(varDeliveryData)?null:(
    <div className="driving-his-card">
      <Link to={`/DeliveryDetail/${varDeliveryData.dc_idx}`} className="driving-state-bar" style={ShowColorDeliveryStatus(varDeliveryData.dc_status)}>{ShowDeliveryStatus(varDeliveryData.dc_status)}</Link>
      <div className="driving-title mb20">{varDeliveryData.cs_name}</div>
      <ul className="driving-destination mb10">
        <li>
          <div className="destination-text">
            <span className="destination-state">상차</span>
            <span className="destination-address">{varDeliveryData.dc_riding_address}</span>
          </div>
        </li>
        {isNull(varDeliveryData.dc_middle_address)?null:
          <li>
            <div className="destination-text">
              <span className="destination-state">경유</span>
              <span className="destination-address">{varDeliveryData.dc_middle_address}</span>
            </div>
          </li>
        }
        <li>
          <div className="destination-text">
            <span className="destination-state">하차</span>
            <span className="destination-address">{varDeliveryData.dc_quit_address}</span>
          </div>
        </li>
      </ul>
      <div className="driving-info-table">
        <dl>
          <dt>하차일</dt>
          <dd>{ChangeDateStringOnlyDate(varDeliveryData.dc_quit_date)}</dd>
          <dt>운행량</dt>
          <dd>{varDeliveryData.dc_volume} Km</dd>
        </dl>
        <dl>
          <dt>상품</dt>
          <dd>{varDeliveryData.dc_prd_name}</dd>
          <dt>수량</dt>
          <dd>{varDeliveryData.dc_prd_quantity}</dd>
        </dl>
        <dl>
          <dt>요청톤</dt>
          <dd>{varDeliveryData.dc_prd_req_ton}톤</dd>
          <dt>전자전표</dt>
          <dd>{varDeliveryData.dc_prd_slip===0?"없음":"있음"}</dd>
        </dl>
        <dl>
          <dt>운임료</dt>
          <dd>{addThousandPoint(varDeliveryData.dc_rprice===0?varDeliveryData.dc_price:varDeliveryData.dc_rprice)} 원</dd>
          <dt>지급원가</dt>
          <dd>{addThousandPoint(varDeliveryData.dc_dprice)+" 원"}</dd>
        </dl>
        <dl>
          <dt>인수증</dt>
          <dd>{varReceiptPayment}</dd>
        </dl>
        <dl>
          <dt>배차담당</dt>
          <dd>
            <span className="tel-text">{varDeliveryData.mem_name+"("+ChangeMobileFormat(varDeliveryData.mem_mobile)+")"}</span>
            <a href={`tel:${varDeliveryData.mem_mobile}`} className="tel">전화걸기</a>
          </dd>
        </dl>
      </div>
    </div>
  );
}
export default DeliveryCard;